import { View, StyleSheet } from "react-native";

interface StatusDotProps {
    color?: string;
    size?: number
}

export const StatusDot = ({ color = "transparent", size = 12 }: StatusDotProps) => {
    return (
        <View style={[styles.dot, { width: size, height: size, backgroundColor: color }]} />
    )
}

const styles = StyleSheet.create({
    dot: { 
        borderRadius: 999,
        marginRight: 8
    },
})